import { render } from "./LearningPath.vue?vue&type=template&id=0d7e13a8"
import script from "./LearningPath.vue?vue&type=script&lang=js"
export * from "./LearningPath.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__